export default "__VITE_ASSET__E$ip1Ur7__"